import { Component, OnInit } from '@angular/core'
import { validateAllFormFields } from '../../../../formUtils'
import {
  UntypedFormBuilder,
  Validators,
  UntypedFormControl,
} from '@angular/forms'
import { MessageService } from 'primeng/api'
import { ReportsService } from '../../../../api/services'
import { Router, ActivatedRoute } from '@angular/router'
import { ReportingSettings } from '../../../../api/models'
import { ReportingSetting } from '../../../../api/models/reporting-setting'

@Component({
  selector: 'app-edit',
  templateUrl: './edit-report.component.html',
  styleUrls: ['./edit-report.component.css'],
})
export class EditReportComponent implements OnInit {
  editreport
  errorValidationSummary: string = ''
  reportId: number
  reportCategoryName: string
    ShowErrorSummary: boolean = false
    reportDsnList: ReportingSetting[];
    selectedDsn?: ReportingSetting;

  constructor(
    private fb: UntypedFormBuilder,
    private messageService: MessageService,
    private reportservice: ReportsService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit() {
    debugger

    this.activatedRoute.queryParams.subscribe((params) => {
      let data = params
      this.reportId = data.report_Id
    })

    this.editreport = this.fb.group({
      reportCategoryName: ['', Validators.required],
      reportDisplayName: ['', Validators.required],
      reportFileName: ['', Validators.required],
      reportShortNote: ['', Validators.required],
      patientFlag: new UntypedFormControl(null, []),
        reportCategoryID: new UntypedFormControl(null, [Validators.required]),
        reportDsnName: ['', Validators.required],
    })
        this.loadReportDsnList();
        this.patchdefaultValues()
  }
  patchdefaultValues() {
    this.reportservice
      .reportsGetRecord({
        reportId: this.reportId,
      })
      .subscribe((data) => {
        if (data) {
          this.editreport.updateValueAndValidity()
          this.editreport.patchValue(data)

            //const reportDsn = this.editreport.get('reportDsnName').value as ReportingSettings;
            //this.editreport.patchValue({
            //    reportDsnName: reportDsn.dsn,
            //});

            //var dsn = this.reportDsnList.filter(report => report.dsn === data.reportDsnName) as ReportingSettings;
            //this.editreport.patchValue({
            //    reportDsnName: dsn,
            //});

            this.selectedDsn = this.reportDsnList.find(
                (dsn) => dsn.dsn === data.reportDsnName,
            )
        }
      })
    }


    loadReportDsnList() {
        this.reportservice.reportsGetDsnList()
            .subscribe((result) => {
                this.reportDsnList = result;
            });
    }


  saveReport() {
    validateAllFormFields(this.editreport)
    if (this.editreport.invalid) {
      return
    }
    debugger

      const reportDsn = this.editreport.get('reportDsnName').value as ReportingSetting;
      this.editreport.patchValue({
          reportDsnName: reportDsn.dsn,
      });

    this.reportservice
      .reportsPut({
        body: this.editreport.value,
        id: this.reportId,
      })
      .subscribe(
        (val) => {
          if (val) {
            this.messageService.add({
              key: 'alertToast',
              severity: 'success',
              summary: 'Confirmation',
              detail: `Report  was updated successfully `,
              life: 5000,
            })
          }
          this.router.navigate(['administration/manage-reports'])
        },
        (err) => {
          this.messageService.add({
            key: 'alertToast',
            severity: 'error',
              summary: 'ERROR',
              detail: `This report display name  is already taken.Please choose another report display name .! `,
            life: 5000,
          })

          //console.log(err.error);
        },
      )
  }
}
